<template>
	<div class="row">
		<div class="col-12">
			<div class="d-flex align-items-center justify-content-between mb-4">
				<h4><i class="fas fa-history"></i> Contato</h4>
				<div>
					<button
						class="btn active btn-outline-secondary btn-sm"
						title="Voltar para Identificação da Família e Endereço"
						@click="$emit('voltar')"
					>
						<i class="mdi mdi-arrow-left"></i>Voltar
					</button>
				</div>
			</div>
		</div>
		<loading-animation
			:active.sync="loading"
			:is-full-page="false"
			:opacity="1"
			color="#5895FF"
		/>
		<div class="col-md-6 mb-3" v-for="contato in contatos" :key="contato.id">
			<div class="card border">
				<div class="card-header bg-gray">
					<p>
						Data: <b>{{ contato.created_at || formatDate }}</b>
					</p>
					<p>
						Técnico: <b>{{ contato.user_id }}</b>
					</p>
				</div>
				<div class="card-body">
					<div v-for="(value, key) in contato" :key="key">
						<p
							v-if="
								key != 'user_id' && key != 'unidade_id' && key != 'id' && key != 'usuario_id'
							"
						>
							{{ setTitle(key) }} :
							<b>{{ setTexto(value) }}</b>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "Read",
	props: ["familiaId"],
	data() {
		return {
			loading: true,
			contatos: {},
		};
	},
	mounted() {
		this.getcontato();
	},
	methods: {
		setTitle(title) {
			return title.replaceAll("_", " ");
		},
		setTexto(text) {
			var str = "";
			if (text == true) {
				str = "Sim";
			} else if (text == false) {
				str = "Não";
			} else {
				str = text;
			}
			return str;
		},
		getcontato() {
			axios
				.get("api/dashboard/familias/historico/contato/" + this.familiaId)
				.then((response) => {
					this.contatos = response.data.data;
					this.loading = false;
				})
				.catch(() => {
					this.$router.push(
						"/dashboard/familias/edit/" + this.familiaId + "/identificacao"
					);
				});
		},
	},
};
</script>
